import { render, staticRenderFns } from "./CrftEdit.vue?vue&type=template&id=065bce12&scoped=true&"
import script from "./CrftEdit.vue?vue&type=script&lang=js&"
export * from "./CrftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065bce12",
  null
  
)

export default component.exports